import React from "react";
import { useLocation } from "react-router";
import Typography from "@mui/material/Typography";

import { NAV_BAR_ITEMS } from "../../../../routes";

const HeaderTitle = () => {
  const location = useLocation();

  const getActiveTitle = () => {
    const pathname = location.pathname;
    if (pathname.startsWith("/settings")) return "Settings";
    if (pathname.startsWith("/profile")) return "Profile";
    if (pathname === "/activity") return "Inventory Replay Logs";

    for (const section of NAV_BAR_ITEMS.flatMap((group) => group.list)) {
      if (section.to === pathname) return section.title;

      if (section.to === "/dashboard") {
        if (
          /\/projects\/[a-z0-9_-]+\/assets/.test(pathname) ||
          /\/clients\/[a-z0-9_-]+\/assets/.test(pathname) ||
          /\/projects\/[a-z0-9_-]+\/capture-inventory/.test(pathname) ||
          /\/clients\/[a-z0-9_-]+\/capture-inventory/.test(pathname)
        ) {
          return section.title;
        }
      } else if (section.to === "/planners" && pathname.indexOf("/planner") === 0) {
        return section.title;
      } else if (section.to === "/warehouse" && pathname.indexOf("/warehouse") === 0) {
        return section.title;
      } else if (
        section.to === "/insights" &&
        /\/projects\/[a-z0-9_-]+\/templates\/[a-z0-9_-]+/.test(pathname)
      ) {
        return section.title;
      } else if (section.to === "/calendar/month" && pathname.indexOf("/calendar") === 0) {
        return section.title;
      } else if (
        section.to === "/inventory/outstanding_orders" &&
        pathname.indexOf("/inventory") === 0
      ) {
        if (pathname.indexOf("/inventory/reserved") === 0) return "Reservations";
        return section.title;
      }
    }
    return "";
  };

  const activeTitle = getActiveTitle();

  return (
    <>
      <title>{activeTitle}</title>
      <Typography
        fontSize={22}
        fontWeight={500}
        color="textSecondary"
        noWrap
        sx={{ minWidth: 0, overflow: "hidden", textOverflow: "ellipsis" }}
      >
        {activeTitle}
      </Typography>
    </>
  );
};

export default HeaderTitle;
